import React from "react";

const styles = {
  "Absolute Beginner": "bg-[#E8F0EC] text-[#3B5648] border-[#4A6B5D]/30",
  Beginner: "bg-[#FBEBE4] text-[#B04B26] border-[#C85A32]/30",
  Improver: "bg-[#FEF3C7] text-[#92600A] border-[#D97706]/40",
  Intermediate: "bg-[#EDE4F5] text-[#6B3FA0] border-[#6B3FA0]/30",
};

export function LevelBadge({ level, className = "" }) {
  const s = styles[level] || "bg-secondary text-secondary-foreground border-border";
  return (
    <span data-testid={`level-badge-${(level || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s} ${className}`}>
      {level}
    </span>
  );
}
